/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveaways_Startsin1Inputs */

const id_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dalam`)
};

const ms_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermula dalam`)
};

const da_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter om`)
};

const de_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnt in`)
};

const en_us2_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts in`)
};

const es_es2_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza en`)
};

const es_mx2_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza en`)
};

const fil_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magsisimula sa`)
};

const fr_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence dans`)
};

const it_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia tra`)
};

const hu_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdődik`)
};

const nl_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start over`)
};

const no_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter om`)
};

const pl_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaczyna się za`)
};

const pt_br2_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts in`)
};

const pt_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa em`)
};

const ro_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Începe în`)
};

const fi_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkaa`)
};

const sv_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börjar om`)
};

const vi_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu trong`)
};

const tr_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç`)
};

const cs_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začíná za`)
};

const bg_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Започва след`)
};

const ru_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинается через`)
};

const uk_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Починається через`)
};

const ar_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبدأ بعد`)
};

const hi_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू होने में`)
};

const th_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มใน`)
};

const ja_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始まで`)
};

const zh_cn2_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts in`)
};

const zh_hant1_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts in`)
};

const ko_components_giveaways_startsin1 = /** @type {(inputs: Components_Giveaways_Startsin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts in`)
};

/**
* | output |
* | --- |
* | "Starts in" |
*
* @param {Components_Giveaways_Startsin1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveaways_startsin1 = /** @type {((inputs?: Components_Giveaways_Startsin1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveaways_Startsin1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveaways_startsin1(inputs)
	if (locale === "ms") return ms_components_giveaways_startsin1(inputs)
	if (locale === "da") return da_components_giveaways_startsin1(inputs)
	if (locale === "de") return de_components_giveaways_startsin1(inputs)
	if (locale === "en-US") return en_us2_components_giveaways_startsin1(inputs)
	if (locale === "es-ES") return es_es2_components_giveaways_startsin1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveaways_startsin1(inputs)
	if (locale === "fil") return fil_components_giveaways_startsin1(inputs)
	if (locale === "fr") return fr_components_giveaways_startsin1(inputs)
	if (locale === "it") return it_components_giveaways_startsin1(inputs)
	if (locale === "hu") return hu_components_giveaways_startsin1(inputs)
	if (locale === "nl") return nl_components_giveaways_startsin1(inputs)
	if (locale === "no") return no_components_giveaways_startsin1(inputs)
	if (locale === "pl") return pl_components_giveaways_startsin1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveaways_startsin1(inputs)
	if (locale === "pt") return pt_components_giveaways_startsin1(inputs)
	if (locale === "ro") return ro_components_giveaways_startsin1(inputs)
	if (locale === "fi") return fi_components_giveaways_startsin1(inputs)
	if (locale === "sv") return sv_components_giveaways_startsin1(inputs)
	if (locale === "vi") return vi_components_giveaways_startsin1(inputs)
	if (locale === "tr") return tr_components_giveaways_startsin1(inputs)
	if (locale === "cs") return cs_components_giveaways_startsin1(inputs)
	if (locale === "bg") return bg_components_giveaways_startsin1(inputs)
	if (locale === "ru") return ru_components_giveaways_startsin1(inputs)
	if (locale === "uk") return uk_components_giveaways_startsin1(inputs)
	if (locale === "ar") return ar_components_giveaways_startsin1(inputs)
	if (locale === "hi") return hi_components_giveaways_startsin1(inputs)
	if (locale === "th") return th_components_giveaways_startsin1(inputs)
	if (locale === "ja") return ja_components_giveaways_startsin1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveaways_startsin1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveaways_startsin1(inputs)
	return ko_components_giveaways_startsin1(inputs)
});
export { components_giveaways_startsin1 as "components.giveaways.startsIn" }